module.exports = __webpack_public_path__ + "474163c3.png";